module.exports = __webpack_public_path__ + "img/funfacts1.dcc650be.png";